<template>
  <div>
    <q-dialog v-model="show" persistent @input="(val) => $emit('input', val)">
      <q-card class="modal-smaller q-pt-md no-scroll">
        <q-card-section class="text-center q-mb-md">
          <q-avatar><img src="~assets/alert-icon.png" alt=""></q-avatar>
          <div class="mt-15">
            <span class="msg-confirm">
              {{ message }}
            </span>
          </div>
        </q-card-section>
        <q-card-actions align="center" class="q-px-md">
          <q-btn unelevated :label="$gettext('NO')" color="grey" class="btn-size" size="md" v-close-popup />
          <q-btn unelevated :label="$gettext('YES')" :color="color" class="btn-size" size="md" @click="confirmAction" />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>

</template>
<script>
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'ConfirmationDialog',
  components: {},
  props: {
    show: Boolean,
    message: String,
    parentCaller: String,
    color: {
      type: String,
      default: 'positive'
    },
    params: {
      type: Object,
      default: {}
    }
  }
})
class ConfirmationDialog extends Vue {
  confirmAction () {
    this.$emit('yes-button', this.parentCaller, this.params)
    this.parentCaller = ''
    this.$emit('input', false)
  }
}

export default ConfirmationDialog

</script>
<style lang="stylus" scoped>

.msg-confirm {
  font-size: 1.5em;
  font-weight: 500;
}

.btn-size {
  width: 120px;
}

</style>
